function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { UI, BuilderIcon, panelFieldStyle } from "../../../builderUiTheme";
import { LEFT_SIDEBAR_TABS, contentBlocks } from "../../constants/defaultBlocks";
import { sectionTemplates, templateCardStyle, renderTemplateThumbnail } from "../../constants/templates";
import { aiResultToPlainText, aiResultToHtmlCode, detectHeadingTagFromAi, looksLikeHtml, normalizeAiCopy, createUniqueBlockId, withDefaultNewBlockMargin } from "../../utils/helpers";
import SidebarBlockGrid from "./SidebarBlockGrid";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var sidebarStyles = "\n  .ws-layers-desc {\n    font-size: 12px;\n    color: #64748b;\n    margin-bottom: 12px;\n    line-height: 1.5;\n    font-family: 'DM Sans', sans-serif;\n  }\n  \n  .ws-layer-item-wrapper {\n    margin-bottom: 6px;\n    transition: all 0.2s ease;\n  }\n  \n  .ws-layer-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #475569;\n    border: 1px solid #e2e8f0;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  \n  .ws-layer-item:hover {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #0f172a;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n  }\n  \n  .ws-layer-item.selected {\n    background: #0f172a;\n    color: #ffffff;\n    border-color: #0f172a;\n    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);\n  }\n  \n  .ws-layer-select-btn {\n    flex: 1;\n    min-width: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    text-align: left;\n    cursor: pointer;\n    font-family: 'DM Sans', sans-serif;\n    font-size: 12px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding: 0;\n  }\n  \n  .ws-layer-type {\n    font-family: 'DM Sans', sans-serif;\n    font-size: 9px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    background: #f1f5f9;\n    color: #475569;\n    padding: 2px 6px;\n    border-radius: 4px;\n    margin-right: 8px;\n    flex-shrink: 0;\n    transition: all 0.15s ease;\n  }\n  \n  .ws-layer-item.selected .ws-layer-type {\n    background: rgba(255, 255, 255, 0.15);\n    color: #ffffff;\n  }\n  \n  .ws-layer-preview {\n    font-family: 'DM Sans', sans-serif;\n    font-size: 12.5px;\n    color: #334155;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-weight: 500;\n  }\n  \n  .ws-layer-item.selected .ws-layer-preview {\n    color: rgba(255, 255, 255, 0.9);\n  }\n  \n  .ws-layer-lock-btn {\n    width: 28px;\n    height: 28px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: #ffffff;\n    color: #64748b;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    flex-shrink: 0;\n    padding: 0;\n  }\n  \n  .ws-layer-lock-btn:hover {\n    background: #f1f5f9;\n    color: #0f172a;\n    border-color: #cbd5e1;\n  }\n  \n  .ws-layer-item.selected .ws-layer-lock-btn {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.15);\n    color: #ffffff;\n  }\n  \n  .ws-layer-item.selected .ws-layer-lock-btn:hover {\n    background: rgba(255, 255, 255, 0.2);\n    border-color: rgba(255, 255, 255, 0.25);\n  }\n  \n  .ws-layer-lock-btn.locked {\n    color: #d97706;\n    background: #fffbeb;\n    border-color: #fde68a;\n  }\n  \n  .ws-layer-lock-btn.locked:hover {\n    background: #fef3c7;\n    border-color: #fcd34d;\n  }\n  \n  .ws-layer-item.selected .ws-layer-lock-btn.locked {\n    color: #fbbf24;\n    background: rgba(251, 191, 36, 0.15);\n    border-color: rgba(251, 191, 36, 0.3);\n  }\n  \n  .ws-layer-item.selected .ws-layer-lock-btn.locked:hover {\n    background: rgba(251, 191, 36, 0.25);\n    border-color: rgba(251, 191, 36, 0.4);\n  }\n\n  /* Slim scrollbar keeps more usable width for the block cards. The standard\n     properties are required: a global scrollbar-color on body makes Chromium\n     ignore the ::-webkit-scrollbar rules below. */\n  .ws-builder-sidebar-body {\n    scrollbar-width: thin;\n    scrollbar-color: #cbd5e1 transparent;\n  }\n\n  .ws-builder-sidebar-body::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  .ws-builder-sidebar-body::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  .ws-builder-sidebar-body::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 999px;\n  }\n\n  .ws-builder-sidebar-body::-webkit-scrollbar-thumb:hover {\n    background: #94a3b8;\n  }\n\n  .ws-sidebar-tab-icon {\n    display: none;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* Narrow screens: tabs become icon-only so the canvas keeps the space */\n  @media (max-width: 1365px) {\n    .ws-sidebar-tab-label { display: none; }\n    .ws-sidebar-tab-icon { display: flex; }\n    .ws-sidebar-tab { padding: 12px 4px; }\n  }\n";
function flattenLayers(nodes) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  (nodes || []).forEach(function (node) {
    var _node$content;
    result.push({
      node: node,
      depth: depth
    });
    var columns = (_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.columns;
    if (Array.isArray(columns) && columns.length > 0 && Array.isArray(columns[0])) {
      columns.forEach(function (column) {
        return flattenLayers(column, depth + 1, result);
      });
    }
  });
  return result;
}
export default function Sidebar(_ref) {
  var activeLeftTab = _ref.activeLeftTab,
    setActiveLeftTab = _ref.setActiveLeftTab,
    add = _ref.add,
    handleDragStartSidebar = _ref.handleDragStartSidebar,
    addSection = _ref.addSection,
    aiProvider = _ref.aiProvider,
    setAiProvider = _ref.setAiProvider,
    aiKeys = _ref.aiKeys,
    setAiKeys = _ref.setAiKeys,
    onAiKeyChange = _ref.onAiKeyChange,
    aiPrompt = _ref.aiPrompt,
    setAiPrompt = _ref.setAiPrompt,
    aiLoading = _ref.aiLoading,
    handleAiGenerate = _ref.handleAiGenerate,
    aiResult = _ref.aiResult,
    change = _ref.change,
    page = _ref.page,
    showToast = _ref.showToast,
    selected = _ref.selected,
    selectBlock = _ref.selectBlock,
    toggleBlockLock = _ref.toggleBlockLock,
    _ref$isCompact = _ref.isCompact,
    isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
    _ref$panelWidth = _ref.panelWidth,
    panelWidth = _ref$panelWidth === void 0 ? 320 : _ref$panelWidth,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? true : _ref$isExpanded,
    onExpand = _ref.onExpand,
    onCollapse = _ref.onCollapse;
  var layers = flattenLayers((page === null || page === void 0 ? void 0 : page.tree) || []);
  var openTab = function openTab(tabId) {
    if (isCompact && isExpanded && activeLeftTab === tabId) {
      if (onCollapse) onCollapse();
      return;
    }
    setActiveLeftTab(tabId);
    if (isCompact && onExpand) onExpand();
  };
  var railButtonStyle = function railButtonStyle(isActive) {
    return {
      width: 40,
      height: 40,
      border: "none",
      borderRadius: 8,
      background: isActive ? "#101828" : "transparent",
      color: isActive ? "#ffffff" : "#64748b",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      padding: 0,
      transition: "all 0.15s ease"
    };
  };
  var rail = isCompact ? /*#__PURE__*/_jsx("div", {
    className: "ws-builder-sidebar-rail",
    style: {
      width: 56,
      flexShrink: 0,
      background: UI.panel,
      borderRight: "1px solid ".concat(UI.panelBorder),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "12px 0",
      gap: 8,
      boxSizing: "border-box",
      zIndex: 20
    },
    children: LEFT_SIDEBAR_TABS.map(function (tab) {
      return /*#__PURE__*/_jsx("button", {
        type: "button",
        title: tab.label,
        "aria-label": tab.label,
        onClick: function onClick() {
          return openTab(tab.id);
        },
        style: railButtonStyle(isExpanded && activeLeftTab === tab.id),
        onMouseEnter: function onMouseEnter(e) {
          if (!(isExpanded && activeLeftTab === tab.id)) {
            e.currentTarget.style.background = "#f1f5f9";
            e.currentTarget.style.color = "#0f172a";
          }
        },
        onMouseLeave: function onMouseLeave(e) {
          if (!(isExpanded && activeLeftTab === tab.id)) {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.color = "#64748b";
          } else {
            e.currentTarget.style.background = "#101828";
            e.currentTarget.style.color = "#ffffff";
          }
        },
        children: /*#__PURE__*/_jsx(BuilderIcon, {
          name: tab.icon,
          size: 18,
          color: "currentColor"
        })
      }, tab.id);
    })
  }) : null;
  if (isCompact && !isExpanded) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("style", {
        dangerouslySetInnerHTML: {
          __html: sidebarStyles
        }
      }), rail]
    });
  }
  var panel = /*#__PURE__*/_jsxs("div", {
    className: "ws-builder-sidebar",
    style: {
      width: isCompact ? 320 : panelWidth,
      maxWidth: "100%",
      background: UI.panel,
      borderRight: "1px solid ".concat(UI.panelBorder),
      display: "flex",
      flexDirection: "column",
      padding: 0,
      boxSizing: "border-box",
      gap: 0,
      height: "100%",
      boxShadow: isCompact ? "8px 0 24px rgba(15, 23, 42, 0.12)" : "none"
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        borderBottom: "1px solid ".concat(UI.panelBorder),
        marginBottom: 0,
        paddingBottom: 0,
        paddingLeft: 8,
        paddingRight: isCompact ? 8 : 8,
        gap: 0,
        alignItems: "stretch",
        minWidth: 0,
        overflow: "hidden"
      },
      children: [LEFT_SIDEBAR_TABS.map(function (tab) {
        return /*#__PURE__*/_jsxs("button", {
          className: "ws-sidebar-tab",
          type: "button",
          title: tab.label,
          "aria-label": tab.label,
          onClick: function onClick() {
            return setActiveLeftTab(tab.id);
          },
          style: {
            flex: "1 1 0",
            minWidth: 0,
            border: "none",
            background: "transparent",
            color: activeLeftTab === tab.id ? UI.tabActiveText : UI.tabInactiveText,
            padding: "10px 4px",
            cursor: "pointer",
            fontFamily: "DM Sans, sans-serif",
            fontSize: 12,
            fontWeight: 500,
            transition: "all 0.15s",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
            borderBottom: activeLeftTab === tab.id ? "2px solid #101828" : "2px solid transparent",
            marginBottom: -1,
            whiteSpace: "nowrap"
          },
          children: [/*#__PURE__*/_jsx("span", {
            className: "ws-sidebar-tab-icon",
            children: /*#__PURE__*/_jsx(BuilderIcon, {
              name: tab.icon,
              size: 18,
              color: "currentColor"
            })
          }), /*#__PURE__*/_jsx("span", {
            className: "ws-sidebar-tab-label",
            children: tab.label
          })]
        }, tab.id);
      }), isCompact && /*#__PURE__*/_jsx("button", {
        type: "button",
        title: "Close",
        "aria-label": "Close sidebar",
        onClick: function onClick() {
          return onCollapse && onCollapse();
        },
        style: _objectSpread(_objectSpread({}, railButtonStyle(false)), {}, {
          width: 32,
          height: 32,
          alignSelf: "center",
          flexShrink: 0
        }),
        children: /*#__PURE__*/_jsx(BuilderIcon, {
          name: "close",
          size: 16,
          color: "currentColor"
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "ws-builder-sidebar-body",
      style: {
        padding: "16px 8px 20px",
        overflowY: "auto",
        flex: "1 0"
      },
      children: [activeLeftTab === "blocks" && /*#__PURE__*/_jsx("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: 14
        },
        children: /*#__PURE__*/_jsx(SidebarBlockGrid, {
          items: contentBlocks,
          onAdd: add,
          onDragStart: handleDragStartSidebar
        })
      }), activeLeftTab === "templates" && /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: 12
        },
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            fontSize: 12,
            color: "#94a3b8",
            fontWeight: 500,
            margin: "0px"
          },
          children: "Drop-in section layouts"
        }), /*#__PURE__*/_jsx("div", {
          style: {
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 10
          },
          children: Object.keys(sectionTemplates).map(function (key) {
            var t = sectionTemplates[key];
            if (!t) return null;
            return /*#__PURE__*/_jsxs("button", {
              type: "button",
              onClick: function onClick() {
                return addSection(key);
              },
              style: templateCardStyle,
              onMouseEnter: function onMouseEnter(e) {
                e.currentTarget.style.borderColor = "#0f172a";
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(15, 23, 42, 0.05)";
              },
              onMouseLeave: function onMouseLeave(e) {
                e.currentTarget.style.borderColor = "#e2e8f0";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              },
              children: [renderTemplateThumbnail(key), /*#__PURE__*/_jsx("span", {
                style: {
                  fontFamily: "DM Sans, sans-serif",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#1e293b",
                  padding: "2px 4px 4px"
                },
                children: t.label
              })]
            }, key);
          })
        })]
      }), activeLeftTab === "layers" && /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          flexDirection: "column"
        },
        children: [/*#__PURE__*/_jsx("div", {
          className: "ws-layers-desc",
          children: "Select overlapping blocks and lock finished elements."
        }), layers.length === 0 ? /*#__PURE__*/_jsx("div", {
          style: {
            color: "#94a3b8",
            fontSize: 13,
            fontFamily: "DM Sans, sans-serif"
          },
          children: "No layers yet."
        }) : layers.map(function (_ref2, index) {
          var _node$content2, _node$content3, _node$content4, _node$content5, _node$content6, _node$content7;
          var node = _ref2.node,
            depth = _ref2.depth;
          var isSelected = selected === node.id;
          return /*#__PURE__*/_jsx("div", {
            className: "ws-layer-item-wrapper",
            style: {
              marginLeft: depth > 0 ? depth * 16 : 0,
              borderLeft: depth > 0 ? "2px solid #cbd5e1" : "none",
              paddingLeft: depth > 0 ? 10 : 0
            },
            children: /*#__PURE__*/_jsxs("div", {
              className: "ws-layer-item ".concat(isSelected ? "selected" : ""),
              children: [/*#__PURE__*/_jsxs("button", {
                type: "button",
                onClick: function onClick() {
                  return selectBlock(node.id);
                },
                className: "ws-layer-select-btn",
                title: "".concat(index + 1, ". ").concat(((_node$content2 = node.content) === null || _node$content2 === void 0 ? void 0 : _node$content2.sectionLabel) || node.type).concat((_node$content3 = node.content) !== null && _node$content3 !== void 0 && _node$content3.text ? " \u2014 ".concat(node.content.text) : ""),
                children: [/*#__PURE__*/_jsx("span", {
                  className: "ws-layer-type",
                  children: ((_node$content4 = node.content) === null || _node$content4 === void 0 ? void 0 : _node$content4.sectionLabel) || node.type
                }), ((_node$content5 = node.content) === null || _node$content5 === void 0 ? void 0 : _node$content5.text) && /*#__PURE__*/_jsx("span", {
                  className: "ws-layer-preview",
                  children: String(node.content.text).slice(0, 20)
                }), node.type === "group" && !((_node$content6 = node.content) !== null && _node$content6 !== void 0 && _node$content6.text) && ((_node$content7 = node.content) === null || _node$content7 === void 0 ? void 0 : _node$content7.sectionLabel) && /*#__PURE__*/_jsx("span", {
                  className: "ws-layer-preview",
                  children: "Section"
                })]
              }), /*#__PURE__*/_jsx("button", {
                type: "button",
                onClick: function onClick() {
                  return toggleBlockLock(node.id);
                },
                title: node.locked ? "Unlock layer" : "Lock layer",
                className: "ws-layer-lock-btn ".concat(node.locked ? "locked" : ""),
                children: node.locked ? /*#__PURE__*/_jsxs("svg", {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  strokeWidth: "2.5",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  children: [/*#__PURE__*/_jsx("rect", {
                    x: "3",
                    y: "11",
                    width: "18",
                    height: "11",
                    rx: "2",
                    ry: "2"
                  }), /*#__PURE__*/_jsx("path", {
                    d: "M7 11V7a5 5 0 0 1 10 0v4"
                  })]
                }) : /*#__PURE__*/_jsxs("svg", {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  strokeWidth: "2.5",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  children: [/*#__PURE__*/_jsx("rect", {
                    x: "3",
                    y: "11",
                    width: "18",
                    height: "11",
                    rx: "2",
                    ry: "2"
                  }), /*#__PURE__*/_jsx("path", {
                    d: "M7 11V7a5 5 0 0 1 9.9-1"
                  })]
                })
              })]
            })
          }, node.id);
        })]
      }), activeLeftTab === "ai" && /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: 14
        },
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h4", {
            style: {
              fontSize: 16,
              fontWeight: 600,
              color: UI.text,
              margin: "0 0 6px 0"
            },
            children: "AI Assistant"
          }), /*#__PURE__*/_jsx("p", {
            style: {
              fontSize: 13,
              fontWeight: 500,
              color: UI.textMuted,
              margin: 0
            },
            children: "Write custom copy. Select your provider and configure your API key."
          })]
        }), /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: 16,
            background: UI.surface,
            padding: 12,
            borderRadius: 8,
            border: "1px solid ".concat(UI.surfaceBorder)
          },
          children: [/*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 4
            },
            children: [/*#__PURE__*/_jsx("label", {
              style: {
                fontSize: 14,
                fontWeight: 600,
                color: UI.textSecondary
              },
              children: "AI Model Provider"
            }), /*#__PURE__*/_jsxs("select", {
              value: aiProvider,
              onChange: function onChange(e) {
                setAiProvider(e.target.value);
              },
              style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                fontFamily: "DM Sans, sans-serif",
                padding: "6px 8px",
                fontSize: 13,
                fontWeight: 500
              }),
              children: [/*#__PURE__*/_jsx("option", {
                value: "demo",
                children: "Demo Mode (Free \u2014 No API)"
              }), /*#__PURE__*/_jsx("option", {
                value: "openai",
                children: "OpenAI (ChatGPT)"
              }), /*#__PURE__*/_jsx("option", {
                value: "gemini",
                children: "Google Gemini (Free tier)"
              }), /*#__PURE__*/_jsx("option", {
                value: "claude",
                children: "Anthropic Claude"
              })]
            })]
          }), aiProvider === "demo" ? /*#__PURE__*/_jsx("div", {
            style: {
              fontSize: 12,
              color: UI.textMuted,
              lineHeight: 1.5,
              padding: "8px 10px",
              background: UI.panel,
              borderRadius: 6,
              border: "1px solid ".concat(UI.surfaceBorder)
            },
            children: "No API key needed. Use this to test the AI panel, copy suggestions, and add blocks to canvas for free."
          }) : /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 4
            },
            children: [/*#__PURE__*/_jsxs("label", {
              style: {
                fontSize: 14,
                fontWeight: 600,
                color: UI.textSecondary,
                display: "flex",
                justifyContent: "space-between"
              },
              children: [/*#__PURE__*/_jsxs("span", {
                style: {
                  textTransform: "capitalize"
                },
                children: [aiProvider, " API Key"]
              }), aiKeys[aiProvider] ? /*#__PURE__*/_jsx("span", {
                style: {
                  color: "#10b981"
                },
                children: "Set"
              }) : /*#__PURE__*/_jsx("span", {
                style: {
                  color: "#6b7280",
                  fontWeight: 500,
                  fontSize: 13,
                  fontFamily: "DM Sans, sans-serif"
                },
                children: "Empty"
              })]
            }), /*#__PURE__*/_jsx("input", {
              type: "password",
              placeholder: aiProvider === "openai" ? "sk-proj-..." : aiProvider === "gemini" ? "AIzaSy..." : "sk-ant-...",
              value: aiKeys[aiProvider] || "",
              onChange: function onChange(e) {
                if (typeof onAiKeyChange === "function") {
                  onAiKeyChange(aiProvider, e.target.value);
                } else if (typeof setAiKeys === "function") {
                  setAiKeys(_objectSpread(_objectSpread({}, aiKeys), {}, _defineProperty({}, aiProvider, e.target.value)));
                }
              },
              style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                fontFamily: "DM Sans, sans-serif",
                fontWeight: 500,
                padding: "8px 10px",
                fontSize: 13
              })
            })]
          }), /*#__PURE__*/_jsx("span", {
            style: {
              fontSize: 12,
              fontWeight: 500,
              color: UI.textFaint
            },
            children: "Keys are saved to your account."
          })]
        }), /*#__PURE__*/_jsx("textarea", {
          rows: 6,
          placeholder: "e.g. Write a project proposal introduction...",
          value: aiPrompt,
          onChange: function onChange(e) {
            return setAiPrompt(e.target.value);
          },
          style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
            fontFamily: "DM Sans, sans-serif",
            fontWeight: 500,
            fontSize: 14,
            borderRadius: 8,
            resize: "none"
          })
        }), /*#__PURE__*/_jsx("button", {
          onClick: handleAiGenerate,
          disabled: aiLoading || !aiPrompt.trim(),
          style: {
            background: '#101828',
            color: "#ffffff",
            border: "none",
            borderRadius: 8,
            padding: "12px 0",
            fontFamily: "DM Sans, sans-serif",
            fontWeight: 600,
            cursor: aiLoading || !aiPrompt.trim() ? "not-allowed" : "pointer",
            opacity: aiLoading || !aiPrompt.trim() ? 0.6 : 1,
            transition: "all 0.2s"
          },
          children: aiLoading ? "Consulting AI..." : aiProvider === "demo" ? "Generate Demo Content" : "Generate Content"
        }), aiResult && /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: 10,
            marginTop: 4
          },
          children: [looksLikeHtml(aiResult) ? /*#__PURE__*/_jsx("div", {
            style: {
              background: UI.surface,
              border: "1px solid ".concat(UI.surfaceBorder),
              borderRadius: 8,
              padding: 12,
              fontSize: 12.5,
              lineHeight: 1.5,
              color: UI.textSecondary
            },
            dangerouslySetInnerHTML: {
              __html: normalizeAiCopy(aiResult)
            }
          }) : /*#__PURE__*/_jsx("div", {
            style: {
              background: UI.surface,
              border: "1px solid ".concat(UI.surfaceBorder),
              borderRadius: 8,
              padding: 12,
              fontSize: 12.5,
              lineHeight: 1.5,
              color: UI.textSecondary,
              whiteSpace: "pre-wrap"
            },
            children: aiResult
          }), /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 8
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("button", {
                onClick: function onClick() {
                  var text = aiResultToPlainText(aiResult);
                  change({
                    tree: [].concat(_toConsumableArray(page.tree), [{
                      id: createUniqueBlockId(),
                      type: "heading",
                      content: {
                        text: text,
                        tag: detectHeadingTagFromAi(aiResult)
                      },
                      style: withDefaultNewBlockMargin({
                        padding: "0",
                        borderRadius: "6px",
                        color: "#1e293b",
                        fontSize: "32px",
                        textAlign: "left",
                        fontWeight: 700
                      })
                    }])
                  });
                  showToast("Heading block added!");
                },
                style: {
                  background: UI.surface,
                  color: UI.text,
                  border: "1px solid ".concat(UI.inputBorder),
                  borderRadius: 6,
                  padding: "8px 0",
                  fontSize: 11,
                  fontWeight: 600,
                  cursor: "pointer"
                },
                children: "+ Heading"
              }), /*#__PURE__*/_jsx("button", {
                onClick: function onClick() {
                  var text = aiResultToPlainText(aiResult);
                  change({
                    tree: [].concat(_toConsumableArray(page.tree), [{
                      id: createUniqueBlockId(),
                      type: "text",
                      content: {
                        text: text
                      },
                      style: withDefaultNewBlockMargin({
                        padding: "0",
                        borderRadius: "6px",
                        color: "#475569",
                        fontSize: "16px",
                        textAlign: "left",
                        lineHeight: 1.6
                      })
                    }])
                  });
                  showToast("Paragraph block added!");
                },
                style: {
                  background: UI.surface,
                  color: UI.text,
                  border: "1px solid ".concat(UI.inputBorder),
                  borderRadius: 6,
                  padding: "8px 0",
                  fontSize: 11,
                  fontWeight: 600,
                  cursor: "pointer"
                },
                children: "+ Paragraph"
              })]
            }), /*#__PURE__*/_jsx("button", {
              onClick: function onClick() {
                change({
                  tree: [].concat(_toConsumableArray(page.tree), [{
                    id: createUniqueBlockId(),
                    type: "html",
                    content: {
                      code: aiResultToHtmlCode(aiResult)
                    },
                    style: withDefaultNewBlockMargin({
                      padding: "10px",
                      borderRadius: "6px"
                    })
                  }])
                });
                showToast("HTML Layout block added!");
              },
              style: {
                background: "#1e1b4b",
                color: "#a5b4fc",
                border: "1px solid #312e81",
                borderRadius: 6,
                padding: "8px 0",
                fontSize: 11,
                fontWeight: 600,
                cursor: "pointer"
              },
              children: "Insert as custom HTML Container"
            })]
          })]
        })]
      })]
    })]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("style", {
      dangerouslySetInnerHTML: {
        __html: sidebarStyles
      }
    }), rail, isCompact && isExpanded && /*#__PURE__*/_jsx("div", {
      onClick: function onClick() {
        return onCollapse && onCollapse();
      },
      style: {
        position: "absolute",
        inset: 0,
        background: "rgba(15, 23, 42, 0.35)",
        zIndex: 40
      }
    }), isCompact && isExpanded ? /*#__PURE__*/_jsx("div", {
      style: {
        position: "absolute",
        top: 0,
        left: 56,
        bottom: 0,
        zIndex: 45,
        display: "flex"
      },
      children: panel
    }) : !isCompact ? panel : null]
  });
}